// @flow
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import UserModalHeader from './components/UserModalHeader/UserModalHeader';
import Tabs from './components/Tabs/Tabs';
import api from '../../services/api';

import locale from '../../locales/index';

class UserSettings extends Component<{
 userID: string,
}, {
  show: boolean,
  saving: boolean,
  user: Object,
  users: Array<Object>,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      show: false,
      user: {},
      saving: false,
      users: [],
    };
  }

  componentWillMount() {
    this.onIdChanged(this.props.userID);
  }

  componentWillReceiveProps(nextProps: Object) {
    this.onIdChanged(nextProps.userID);
  }

  onIdChanged(id: string) {
    if (id !== '') {
      api.users.get(id, (res) => {
        this.onUserReceived(res);
      });
    } else {
      this.setState({ show: false, user: {} });
    }
  }

  onUserReceived(data: Object) {
    this.setState({ show: true, user: JSON.parse(data) });
  }

  close() {
    this.setState({ show: false });
  }

  save() {
    if (!this.state.saving) {
      this.setState({ saving: true });

      let user = this.state.user;
      this.tabPanel.tabs.forEach((tab) => {
        if (tab && tab.save) {
          user = tab.save(user);
        }
      });

      console.log(user);

      api.users.save(this.state.user.id, user, (e) => {
        console.log(e);
        this.setState({ saving: false });
        this.close();
      });
    }
  }

  tabPanel: Object;

  render() {
    console.log(this.state.user);
    const profile = this.state.user.profile;
    let visible = this.state.show;

    if (!profile) visible = false;

    return (
      <Modal show={visible} bsSize="large" onHide={() => this.close()}>
        <Modal.Header closeButton>
          <UserModalHeader
            givenName={(visible) ? profile.name.givenName : ''}
            familyName={(visible) ? profile.name.familyName : ''}
            image={(visible) ? profile.image.url : ''}
            tagLine={(visible) ? profile.tagline : ''}
          />
        </Modal.Header>
        <Modal.Body>
          <Tabs
            user={this.state.user}
            ref={(instance) => { this.tabPanel = instance; }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.close()}>{locale.cancel}</Button>
          <Button bsStyle="primary" onClick={() => this.save()}>{this.state.saving ? locale.saving : locale.save}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default UserSettings;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/UserSettings.js